import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { endpoints } from '../constants/auth.constants';
import { AuthService } from '@app/core/services/auth.service';
import { TbtStorageService } from '../services/tbt-storage.service';
import { environment } from '@env/environment';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const tbtStorageService = inject(TbtStorageService);

  const isSalesforceTokenRefresh =
    req.url.includes(endpoints.designs) ||
    req.url.includes(endpoints.templates) ||
    req.url.includes(endpoints.query);

  const isAPIGatewayEndpoint = req.url.includes(authService.getAWSUrl());

  if (isSalesforceTokenRefresh) {
    const authToken = tbtStorageService.getItem('access_token', true);

    req = authToken
      ? req.clone({
          setHeaders: {
            Authorization: `Bearer ${authToken}`,
          },
        })
      : req;
  }

  if (isAPIGatewayEndpoint) {
    const idp = tbtStorageService.getItem('idp', true);
    let auth = tbtStorageService.getItem('idp_access_token', true);
    if (idp && idp === 'SF') {
      auth = tbtStorageService.getItem('authToken', true);
    }

    // req = req.clone({
    //   setHeaders: {
    //     Authorization: `${auth}`,
    //     idp: idp ?? 'cognito',
    //   },
    // });
      req = req.clone({
        setHeaders: {
          'X-Merck-APIKey': environment.apiProxyKey,
          idp: 'APIP',
          Authorization: '8BimGOUJieA9c9a5jxpwXjT7RTfAR0AW8UL5pueHC6sRMJkpQxCRqUyB936yfI2g'
        },  
      });

    if (idp && idp === 'SF') {
      req = req.clone({
        setHeaders: {
          'X-Merck-APIKey': environment.apiProxyKey,
        },  
      });
    }
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('HTTP Error:', error);
      if (error) {
        switch (error.status) {
          case 401:
            if (isSalesforceTokenRefresh) {
              return handleSF401(authService, req, next);
            }
            break;
          default:
            throw error;
        }
      }
      throw error;
    })
  );
}

function handleSF401(
  authService: AuthService,
  req: HttpRequest<unknown>,
  next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>
) {
  return authService.getNewToken().pipe(
    switchMap((newToken) => {
      const retry = req.clone({
        setHeaders: {
          Authorization: `Bearer ${newToken}`,
        },
      });
      return next(retry);
    })
  );
}
